import * as React from 'react';
import { Box, Grid, Button, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TextField } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Skeleton from '@mui/material/Skeleton';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import SearchIcon from '@mui/icons-material/Search';
import CachedIcon from '@mui/icons-material/Cached';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';


const GetTimeFormat = (time) => {
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    hours = Math.floor(time / 3600);
    minutes = Math.floor((time - (hours * 3600)) / 60);
    seconds = time - (hours * 3600) - (minutes * 60);

    if (hours == 0) {
        hours = '';
    }
    else {
        hours = hours + ' H ';
    }


    if (minutes == 0) {
        minutes = '';
    }
    else {
        minutes = minutes + ' M ';
    }

    if (seconds == 0) {
        seconds = '';
    }
    else {
        seconds = seconds + ' S ';
    }


    let final_time = hours + minutes + seconds;

    if (final_time == '') {
        final_time = 0
    }

    return final_time;
}

export const DashboardCallComp = (props) => {
    return (
        <Box>
            <Box>
                <Grid container>
                    <Grid md={3}>
                        <Box marginTop={-1}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker onChange={(e) => props.HandleInputs(e, 'txtSearchStartDate')} label="Start Date" value={dayjs(props.mystate.txtSearchStartDate)} />
                                </DemoContainer>
                            </LocalizationProvider>
                        </Box>
                    </Grid>
                    <Grid md={3}>
                        <Box marginTop={-1}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker onChange={(e) => props.HandleInputs(e, 'txtSearchEndDate')} label="End Date" value={dayjs(props.mystate.txtSearchEndDate)} />
                                </DemoContainer>
                            </LocalizationProvider>
                        </Box>
                    </Grid>

                     <Grid xs={12} md={3}>
                                                    <Box>
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                select
                                                                value={props.mystate.ddlSearchUser || ''}
                                                                label="Select User"
                                                                onChange={(e) => props.HandleInputs(e, 'ddlSearchUser')}
                                                            >
                                                                {
                                                                    props.mystate.userListData.length > 0 ?

                                                                        props.mystate.userListData.map((item) =>
                                                                             item.user_profile_name.includes('Sales') ?
                                                                                <MenuItem value={item.user_name}>{item.user_name}</MenuItem>
                                                                                :
                                                                                null
                                                                        )
                                                                        :
                                                                        null
                                                                }
                                                            </TextField>
                                                            
                                                        </FormControl>
                                                    </Box>
                                                </Grid>



                    <Grid md={2}>
                        <Box textAlign={'end'}>
                            <Button style={{ margin: 10 }} variant="outlined" onClick={() => props.CustomSearch()}><SearchIcon></SearchIcon></Button>
                            <Button style={{ margin: 10 }} variant="outlined" onClick={() => props.Reload()}><CachedIcon></CachedIcon></Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box style={{ marginTop: '20px' }}>
                {
                    props.mystate.getCallLogsCount === false ?
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <TableContainer sx={{ maxHeight: 'calc(100vh - 200px)' }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                key={'SrNo'}
                                                align={'left'}
                                                style={{}}
                                                className='table-head-cell'
                                            >
                                                {'Sr. No'}
                                            </TableCell>
                                            <TableCell
                                                key={'Name'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {'Name'}
                                            </TableCell>
                                            <TableCell
                                                key={'Dialled'}
                                                align={'left'}
                                                style={{}}
                                                className='table-head-cell'
                                            >
                                                {'Dialled'}
                                            </TableCell>
                                            <TableCell
                                                key={'Connected'}
                                                align={'left'}
                                                style={{}}
                                                className='table-head-cell'
                                            >
                                                {'Connected'}
                                            </TableCell>
                                            <TableCell
                                                key={'Total Talktime'}
                                                align={'left'}
                                                style={{}}
                                                className='table-head-cell'
                                            >
                                                {'Total Talktime'}
                                            </TableCell>
                                            <TableCell
                                                key={'Avg Talktime'}
                                                align={'left'}
                                                style={{}}
                                                className='table-head-cell'
                                            >
                                                {'Avg Talktime'}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {props.mystate.callCountData.length > 0 ?
                                            props.mystate.callCountData.map((item, i) => (
                                                item.user_name != undefined && item.user_name != '' ?
                                                    <TableRow hover tabIndex={-1} key={item._id}>
                                                        <TableCell key={i} align={'left'}>
                                                            {i + 1}
                                                        </TableCell>
                                                        <TableCell key={item.user_name + i} align={'left'}>
                                                            {item.user_name}
                                                        </TableCell>
                                                        <TableCell key={item.dialled + i} align={'left'}>
                                                            {item.dialled}
                                                        </TableCell>
                                                        <TableCell key={item.connected + i} align={'left'}>
                                                            {item.connected}
                                                        </TableCell>
                                                        <TableCell key={item.duration + i} style={{ fontSize: 12 }} align={'left'}>
                                                            {GetTimeFormat(item.duration)}
                                                        </TableCell>
                                                        <TableCell key={item.duration + i} style={{ fontSize: 12 }} align={'left'}>

                                                            {
                                                                item.duration == 0 || item.connected == 0 ?
                                                                    0
                                                                    :
                                                                    GetTimeFormat(Math.floor(item.duration / item.connected))
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                    :
                                                    ''
                                            ))
                                            :
                                            "No Record Found"
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        :
                        <Box>
                            <Skeleton height={75} />
                            <Skeleton animation="wave" variant="rectangular" height={250} />
                            <Skeleton height={75} />
                        </Box>
                }

            </Box>

            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={props.mystate.showAlert} autoHideDuration={2000} onClose={() => { props.handleCloseAlert() }}>
                <Alert
                    onClose={() => { props.handleCloseAlert() }}
                    severity={'error'}
                    variant="filled"
                    sx={{ width: '100%' }}

                >
                    {props.mystate.alertMsg}
                </Alert>
            </Snackbar>
        </Box>


    );
}